import * as React from 'react';
import withPlaybackContext from '../../common/withPlaybackContext';
import { classes } from './TrackName.st.css';
var TrackName = function (props) { return (React.createElement("span", { className: classes.title + " " + props.className, "data-hook": props.dataHook }, props.value || props.context.trackName)); };
TrackName.displayName = 'TrackName';
TrackName.defaultProps = {
    className: '',
    dataHook: '',
};
export default withPlaybackContext(TrackName);
//# sourceMappingURL=TrackName.js.map